var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"an-edit-button"},[_c('router-link',{staticClass:"an-edit-button__button",attrs:{"to":("/fragebogen?step=" + _vm.sectionId + "&field=" + _vm.fieldId)}},[_c('IconEdit')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }